import { AdminSidepotTestScreen } from '@/screens/admin/admin-sidepot-test-screen'

export default function () {
  return <AdminSidepotTestScreen />
}
